import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Collapse,
  Tooltip,
  Divider,
} from "@mui/material";

import styles from "../Styles/mainSlider.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { Fragment, useState, useMemo, useEffect } from "react";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { mainPathMatches, isFreeSubscription } from "../Utils/Utils";
import { MainSliderProps } from "../Utils/Types";
import withRole from "../Hooks/withRole";
import BookIcon from "@mui/icons-material/Book";
import { localUrlEnum, endpoints } from "../Utils/UrlEnum";
import { getData } from "../Services/getData";

function MainSlider(props: MainSliderProps, location: any) {
  location = useLocation();
  const navigate = useNavigate();
  const [openMenus, setOpenMenus] = useState<{ [key: number]: boolean }>({});
  const [courses, setCourses] = useState<any[]>([]);

  useEffect(() => {
    const clientId = localStorage.getItem("clientId");
    if (!clientId) return;
    getData(`${endpoints.courses}/byClient/${clientId}`).then((response) => {
      if (response.data) setCourses(response.data);
    });
  }, []);

  // Filter menu items for free subscriptions
  const token = localStorage.getItem("access_token");
  const filteredData = useMemo(() => {
    if (!isFreeSubscription() || !props.data) return props.data;

    return props.data.filter(
      (item: any) =>
        item.path !== localUrlEnum.statistics &&
        item.path !== localUrlEnum.liveLegislation &&
        item.path !== localUrlEnum.drivingSessionScheduling
    );
  }, [props.data, token]);

  const isActive = (path: string) => {
    return mainPathMatches(path, location.pathname);
  };

  const handleToggleMenu = (key: number) => {
    setOpenMenus((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleNavigate = (path: string) => {
    navigate(path);
    props.setHideSlider();
  };

  const renderMainItem = (element: any, key: any) => {
    const active = isActive(element.path);

    return (
      <ListItem key={key} disablePadding className={styles.listItem}>
        <Tooltip title={element.name} placement="right" arrow>
          <ListItemButton
            className={`${styles.navButton} ${active ? styles.active : ""}`}
            onClick={() => handleNavigate(element.path)}
          >
            <ListItemIcon className={styles.navIcon}>
              {element.icon}
            </ListItemIcon>
            <ListItemText primary={element.name} className={styles.navText} />
          </ListItemButton>
        </Tooltip>
      </ListItem>
    );
  };

  const renderModuleItem = (element: any, key: any) => {
    const active = mainPathMatches(element._id, location.pathname);

    return (
      <ListItem key={key} disablePadding className={styles.listItem}>
        <Tooltip title={element.name} placement="right" arrow>
          <ListItemButton
            className={`${styles.navButton} ${active ? styles.active : ""}`}
            onClick={() =>
              handleNavigate(localUrlEnum?.courses + "/" + element._id)
            }
          >
            <ListItemIcon className={styles.navIcon}>
              <BookIcon />
            </ListItemIcon>
            <ListItemText primary={element.name} className={styles.navText} />
          </ListItemButton>
        </Tooltip>
      </ListItem>
    );
  };

  const renderCollapsibleItem = (element: any, key: any) => {
    const isOpen = openMenus[key] || false;
    const hasActiveChild = element.children?.some((child: any) =>
      isActive(child.path)
    );

    return (
      <Fragment key={key}>
        <ListItem disablePadding className={styles.listItem}>
          <Tooltip title={element.name} placement="right" arrow>
            <ListItemButton
              className={`${styles.navButton} ${
                hasActiveChild ? styles.active : ""
              }`}
              onClick={() => handleToggleMenu(key)}
            >
              <ListItemIcon className={styles.navIcon}>
                {element.icon}
              </ListItemIcon>
              <ListItemText primary={element.name} className={styles.navText} />
              {isOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
          </Tooltip>
        </ListItem>
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding className={styles.subMenu}>
            {element.children?.map((child: any, childKey: any) => (
              <ListItem key={childKey} disablePadding>
                <ListItemButton
                  className={`${styles.subNavButton} ${
                    isActive(child.path) ? styles.activeSubNav : ""
                  }`}
                  onClick={() => handleNavigate(child.path)}
                >
                  <ListItemIcon className={styles.subNavIcon}>
                    {child.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={child.name}
                    className={styles.subNavText}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Collapse>
      </Fragment>
    );
  };

  return (
    <Box className={styles.container}>
      <Box className={styles.slider}>
        <List className={styles.navList}>
          {/* Courses */}
          {courses && courses.length > 0 && (
            <>
              <Typography variant="caption" className={styles.sectionTitle}>
                Cursuri
              </Typography>
              {courses.map((element: any, key: any) =>
                renderModuleItem(element, `course-${key}`)
              )}
            </>
          )}

          <Divider className={styles.divider} />
          {/* Main Navigation Items */}
          {filteredData && filteredData.length > 0 && (
            <>
              {filteredData.map((element: any, key: any) =>
                element.children
                  ? renderCollapsibleItem(element, key)
                  : renderMainItem(element, key)
              )}
            </>
          )}
        </List>
      </Box>
    </Box>
  );
}

export default withRole(MainSlider);
